export {
  EXTERIOR_DESIGN_STYLES,
  EXTERIOR_DESIGN_STYLE_DEFAULT,
  BUILDING_EXTERIOR_STYLE_LABELS,
  findExteriorStyleByLabel,
  resolveExteriorStylePromptLabel,
} from '../data/exteriorDesignStyles';

/** @deprecated Use BUILDING_EXTERIOR_STYLE_LABELS — kept for import compatibility */
export { BUILDING_EXTERIOR_STYLE_LABELS as BUILDING_EXTERIOR_STYLES } from '../data/exteriorDesignStyles';

export const EXTERIOR_CHANGE_LEVELS = [
  'Light Facade Refresh',
  'Balanced Exterior Redesign',
  'Full Exterior Transformation',
];

export const EXTERIOR_CHANGE_LEVEL_DEFAULT = 'Full Exterior Transformation';

export const FACADE_MATERIALS = [
  'AI Choice',
  'Stone',
  'Wood',
  'Concrete',
  'Metal',
  'Glass',
  'Brick',
  'Stucco',
  'Mixed Materials',
];

export const FACADE_MATERIAL_DEFAULT = 'AI Choice';

export const TIME_OF_DAY_OPTIONS = ['Day', 'Sunset', 'Night'];

export const TIME_OF_DAY_DEFAULT = 'Day';

export const WEATHER_OPTIONS = ['Spring', 'Summer', 'Autumn', 'Winter'];

export const WEATHER_DEFAULT = 'Spring';
